export default {
  namespaced: true,
  state: {
    hasScrolledDown: false,
  },
  getters: {
    getHasScrolledDownState(state) {
      return state.hasScrolledDown;
    },
  },
  actions: {
    setHasScrolledDown: (context, data) => {
      context.commit("setHasScrolledDown", data);
    },
  },
  mutations: {
    setHasScrolledDown: (state, bool) => {
      state.hasScrolledDown = bool;
    },
  },
};
